export default __webpack_public_path__ + "static/img-slider-02-1399484bcc30bbffd5097a1c1c3ff356.png";